import { NotificationHistory } from 'admin/notifications/Notifications.types';
import { getActionLabelKey } from 'common/notification-tray/desktop-alert-registry/DesktopAlertRegistry';

const TYPE_TO_EVENT_TYPE: Partial<Record<number, string>> = {
    39: 'ElasticReview',
    44: 'FieldsMissingOnProfiles',
};

export const getEffectiveEventType = (notification: NotificationHistory): string | null => {
    return notification.eventType || TYPE_TO_EVENT_TYPE[notification.type] || null;
};

export const getActionLabelKeyForNotification = (notification: NotificationHistory): string | null => {
    const effectiveEventType = getEffectiveEventType(notification);

    if (effectiveEventType) {
        return getActionLabelKey(effectiveEventType) || 'TAKE_ACTION';
    }
    return null;
};
